<template>
  <div
    :class="$style.commands"
  >
    <HeadingExtraSmall>
      Device Support
      <IconTooltip :tooltipContainerClass="$style.tooltip">
        <p>
          Use Remote Assist to remotely access user devices for support and maintenance.
        </p>
      </IconTooltip>
      <NewBadge />
    </HeadingExtraSmall>
    <ul :class="$style.sectionContent">
      <li :class="$style.sectionContentItem">
        <IconButton
          :class="$style.DeviceSupportCommands__button"
          icon="externalLink"
          iconPosition="right"
          :isDisabled="!launchRemoteAssistStatus"
          :isMatchText="false"
          isFullWidth
          :scale="0.5"
          text="launch remote assist"
          textCase="lowercase"
          type="secondary"
          @click="handleLaunchRemoteAssist"
        />
      </li>
    </ul>
  </div>
</template>

<script>
import { HeadingExtraSmall, IconButton } from '@jumpcloud/ui-components';
import {
  ItemTypeConsts,
  StoreModelMap,
} from 'util/Constants';
import { StoreModuleMap } from 'client/util/Constants';
import { implementationChecklistTasks } from 'client/GrowthEngineering/utilities/GrowthConstants';
import { mapActions, mapGetters } from 'vuex';
import { notify } from 'client/util';
import ConfigService from 'client/util/ConfigService';
import IconTooltip from 'components/Tooltip/IconTooltip';
import NewBadge from 'client/components/Badges/NewBadge.vue';
import RemoteAssistApi from 'api/v2/RemoteAssistApi';

const { system } = ItemTypeConsts;
const onboardingModule = 'OnboardingModule';
const systemModel = StoreModelMap[system];
const settingsModule = StoreModuleMap[ItemTypeConsts.settings];

export default {
  name: 'DeviceSupportCommands',

  components: {
    HeadingExtraSmall,
    IconButton,
    IconTooltip,
    NewBadge,
  },

  computed: {
    ...mapGetters(systemModel, [
      'id',
      'isActive',
    ]),

    ...mapGetters(settingsModule, [
      'hasRemoteAssistScope',
      'hasRemoteAssistSessionsScope',
    ]),

    launchRemoteAssistStatus() {
      return this.hasRemoteAssistScope || this.hasRemoteAssistSessionsScope;
    },
  },

  methods: {
    ...mapActions(onboardingModule, [
      'updateImplementationTaskStatusAuto',
    ]),

    handleLaunchRemoteAssist() {
      RemoteAssistApi.getToken({ system_id: this.id })
        .then((response) => {
          this.updateImplementationTaskStatusAuto({
            taskType: implementationChecklistTasks.launchRemoteAssist,
          });
          let retryCount = 10;
          const remoteAssistWindow = window.open(ConfigService.remoteAssistAdminUrl, '_blank');
          if (!remoteAssistWindow || remoteAssistWindow.closed || typeof remoteAssistWindow.closed === 'undefined') {
            notify("Popups are disabled for this site. Remote session might not work correctly the first time. While subsequent attempts will resolve this, JumpCloud's recommendation is to allow popups for this site permanently in your browser settings.");
          }
          const intervalId = setInterval(() => {
            if (remoteAssistWindow) {
              const msg = {
                promptedAssist: this.$hasFeatureFlag(this.$featureFlags.promptedAssist),
                active: this.isActive,
                token: response.token,
              };
              remoteAssistWindow.postMessage(msg, ConfigService.remoteAssistAdminUrl);
            }
            retryCount -= 1;
            if (retryCount === 0) {
              window.clearInterval(intervalId);
            }
          }, 2000);
        })
        .catch(() => notify('Unable to launch remote assist'));
    },
  },
};
</script>

<style module>
  .commands a:hover {
    cursor: pointer;
  }

  .commands {
    border-top: 0.06rem solid var(--jcGrey300) !important;
    margin: 1.25rem;
    padding-top: 1.25rem;
  }

  .DeviceSupportCommands__button {
    border-radius: 0.125rem !important;
  }

  .sectionContent {
    list-style-type: none;
    padding: 1.25rem 0;
  }

  .sectionContentItem {
    margin: 0.3rem 0 0.6rem 0;
  }

  .tooltip {
    margin-left: 0.3rem;
    margin-right: 0.6rem;
    position: relative;
    top: 0;
  }
</style>
